__turbopack_context__.v({
  "accountButton": "SidebarContainer-module-scss-module__VLQKuG__accountButton",
  "blocksBackgroundColor": "SidebarContainer-module-scss-module__VLQKuG__blocksBackgroundColor",
  "blocksFontColor": "SidebarContainer-module-scss-module__VLQKuG__blocksFontColor",
  "container": "SidebarContainer-module-scss-module__VLQKuG__container",
  "noAccessContainer": "SidebarContainer-module-scss-module__VLQKuG__noAccessContainer",
  "secondaryNavBackgroundColor": "SidebarContainer-module-scss-module__VLQKuG__secondaryNavBackgroundColor",
  "sidebarHeader": "SidebarContainer-module-scss-module__VLQKuG__sidebarHeader",
  "sidebarHeaderLight": "SidebarContainer-module-scss-module__VLQKuG__sidebarHeaderLight",
  "themeBackgroundColor": "SidebarContainer-module-scss-module__VLQKuG__themeBackgroundColor",
  "themeFontColor": "SidebarContainer-module-scss-module__VLQKuG__themeFontColor",
  "themeFontFamily": "SidebarContainer-module-scss-module__VLQKuG__themeFontFamily",
  "topExitButton": "SidebarContainer-module-scss-module__VLQKuG__topExitButton",
  "topNavButton": "SidebarContainer-module-scss-module__VLQKuG__topNavButton",
});
